import SiteLayout from '@/components/feature/SiteLayout';
import Seo from '@/components/feature/Seo';
import HeroSection from '@/pages/home/components/HeroSection';
import CategorySection from '@/pages/home/components/CategorySection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import LatestSection from '@/pages/home/components/LatestSection';
import FaqSection from '@/pages/home/components/FaqSection';
import CtaSection from '@/pages/home/components/CtaSection';
import { faqs } from '@/mocks/faqs';
import { site } from '@/mocks/site';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: site.name,
    url: 'https://xwatched.cn/',
    description: site.description,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://xwatched.cn/topics?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: site.name,
    url: 'https://xwatched.cn/',
    email: site.email,
    description: site.description,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  },
];

export default function Home() {
  return (
    <SiteLayout>
      <Seo
        title="瓜田黑料 | 娱乐热点时间线复盘与舆论观察站"
        description="瓜田黑料专注娱乐热点的时间线复盘与舆论观察，把公开物料按时间排好，梳理事件起势、发酵与收场的关键节点，帮你理性吃瓜不迷路。"
        keywords="瓜田黑料,娱乐热点复盘,舆论观察,时间线整理,吃瓜指南"
        path="/"
        jsonLd={jsonLd}
      />
      <HeroSection />
      <CategorySection />
      <FeaturedSection />
      <LatestSection />
      <FaqSection />
      <CtaSection />
    </SiteLayout>
  );
}